<template>
  <div class="l-height-100">
    <Geo :map-data="collisionLocations" 
         :marker-click-action="'collisionsView/collision/fetch'"
         :map-active="mapActive"
         ref="geo">
    </Geo>
  </div>
</template>

<script>
import Geo from '@/components/Geo'

export default {
  name: 'collisionMap',

  components: {
    'Geo': Geo
  },

  props: ['mapActive'],

  computed: {
    collisionLocations () {
      return this.$store.getters['collisionsView/collisionLocations/get']
    }
  }
}
</script>



// WEBPACK FOOTER //
// CollisionMap.vue?07c8ca52